<template>
  <div>
    <div style="padding: 1rem 1.5rem;">
      <a-row>
        <a-col :span="11">
          <div style="display:flex;align-items: center;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">派息日期</div>
            <a-date-picker v-model="form.dividends_date" :disabled-date="disabledDate" style="width: 100%" @change='timehand' :placeholder="'請選擇派息時間'" />
          </div>
        </a-col>
        <a-col :span="2"></a-col>
        <a-col :span="11">
          <div style="display:flex;align-items: center;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">股票市場</div>
            <a-select  ref="select" v-model="form.market"  @change="marketOn(form.market)" placeholder="請選擇股票市場" style="width: 100%;">
              <a-select-option value="港股">港股</a-select-option>
              <a-select-option value="美股">美股</a-select-option>
            </a-select>
          </div>
        </a-col>
      </a-row>
      <a-row style="margin-top:1.5rem">
        <a-col :span="11">
          <div style="display:flex;align-items: center;position: relative;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">股票代碼</div>
            <!-- onkeyup="value=value.replace(/[\u4E00-\u9FA5]/g,''); value=value.replace(/[^\d]/g,'')" --> 
            <!-- <a-input v-model="form.stockcode" placeholder="請輸入股票代碼" :maxLength="form.market == '港股'? '5':'10'" @input="stockcodeOn()"/> -->
            <a-auto-complete :data-source="tabData1" :style="'width: 100%'" @search="handleSearch" @change="stockcodeOn(form.stockcode)" placeholder="請輸入股票代碼" @focus='focus' v-model="form.stockcode" ></a-auto-complete>
            <span style="position:absolute;right: 4%;" v-if="form.stockcode && form.market == '港股'">.HK</span>
            <span style="position:absolute;right: 4%;" v-if="form.stockcode && form.market == '美股'">.US</span>
          </div>
        </a-col>
        <a-col :span="2"></a-col>
        <a-col :span="11">
          <div style="display:flex;align-items: center;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">股票名稱</div>
            <a-input  v-model="form.stockname" :title="form.stockname" style="color:#000;" :disabled="true" placeholder="請輸入股票名稱" @input="stocknameOn()" />
          </div>
        </a-col>
      </a-row>
      <a-row style="margin:1.5rem 0">
        <a-col :span="11">
          <div style="display:flex;align-items: center;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">派息幣種</div>
            <a-select  ref="select" v-model="form.dividends_ccytype"  placeholder="請選擇派息幣種" style="width: 100%;">
              <a-select-option value="HKD">HKD</a-select-option>
              <a-select-option value="USD">USD</a-select-option>
            </a-select>
          </div>
        </a-col>
        <a-col :span="2"></a-col>
        <a-col :span="11">
          <div style="display:flex;align-items: center;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">派息金額</div>
            <!-- <a-input  v-model="form.dividends_price" placeholder="請輸入派息金額"/> -->
            <el-input v-model="form.dividends_price" placeholder="請輸入派息金額" class="numrule" type="number" />
          </div>
        </a-col>
      </a-row>
    </div>
    <div style="border-top:1px solid #e5e5e5;display: flex;justify-content: end;padding: 1rem 1rem 0.6rem 0;">
      <div style="background:#0c8b97; padding: 0.6rem 2rem;color:#fff;font-size: 0.8rem;cursor: pointer;" @click="newStockdividends()">提交</div>
    </div>
  </div>
</template>

<script>
import App from "@/assets/app.js";
import moment from 'moment'
export default {
  props:['isval','father'],
  data(){
			return {
        tabData: [],
        tabData1: [],
        form:{
          dividends_date:'',
          market:undefined,
          stockcode:'',
          stockname:'',
          dividends_ccytype:undefined,
          dividends_price:'',
          username:this.isval.username,
        }
			}
		},
    // watch: {
		// 	val: {
		// 		immediate: true,
		// 		handler(ev) {
		// 			if (ev) {
    //         console.log(ev);
		// 				setTimeout(()=>{
		// 					this.stockcodeOn(ev)
		// 				},100)
		// 			}
		// 		}
		// 	},
		// },
		mounted() {
		},
		methods:{ 
      disabledDate(current) {
        return current && current < moment().subtract(1, 'days').endOf('day')
      },
      focus(){
        // if (this.form.market == '港股') {
        //   this.form.stockcode=this.form.stockcode.replace(/[^\d]/g,'');
        // }else{
        //   this.form.stockcode=this.form.stockcode.replace(/[\u4E00-\u9FA5]/g,'');
        // }
        this.getdata()
      },
      handleSearch(val) {
				this.form.stockcode = val
				this.tabData = []
				if(val){
					this.getdata(val);
          this.stockcodeOn(val)
				}
			},
      getdata(){
				this.$ajax({
					method: 'post',
					url:  this.$api.getParamList,
					headers: {
						token: this.$store.state.token
					},
					data: {
            searchstr:this.form.stockcode,
            type:'stocks',
            market:this.form.market,
          }
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.tabData = res.data.result;
            this.tabData1=[];
            for (let i = 0; i < this.tabData.length; i++) {
              let tab = this.tabData[i]
              this.tabData1.push(tab.stockcode)
            }
						
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
      },
      marketOn(val){
        this.form.stockcode ='';
        this.form.stockname ='';
        if (val == '港股') {
          this.form.dividends_ccytype = 'HKD'
        }else{
          this.form.dividends_ccytype = 'USD'

        }
        
      },
      stockcodeOn(val){
        if (this.form.market == '港股') {
          this.form.stockcode=this.form.stockcode.replace(/[^\d]/g,'');
        }else{
          this.form.stockcode=this.form.stockcode.replace(/[\u4E00-\u9FA5]/g,'');
        }
        if (this.tabData.length<=0) {
          this.form.stockname ='';
        }
        for (let i = 0; i < this.tabData.length; i++) {
          let tab = this.tabData[i];
          if (tab.stockcode == val) {
            this.form.stockname = tab.stockname;
            return
          }else{
            this.form.stockname = '';
          }
          
        }
      },
      stocknameOn(){
        if (this.form.market == '美股') {
          this.form.stockname=this.form.stockname.replace(/[^a-zA-Z]/g,'');
        }
      },
      timehand(){
        this.form.dividends_date = App.oDate.secsTime3(this.form.dividends_date._d)
      },
      newStockdividends(){
        console.log(this.form.dividends_date);
        if (!this.form.dividends_date) {
          App.oTool.warningT("請選擇派息時間");
          return
        }
        if (!this.form.market) {
          App.oTool.warningT("請選擇股票市場");
          return
        }
        if (!this.form.stockcode) {
          App.oTool.warningT("請輸入股票代碼");
          return
        }

        if (!this.form.stockname) {
          App.oTool.warningT("請重新輸入股票名稱");
          return
        }
        if (!this.form.dividends_ccytype) {
          App.oTool.warningT("請選擇派息幣種");
          return
        }
        if (!this.form.dividends_price) {
          App.oTool.warningT("請輸入派息金額");
          return
        }
        this.$ajax({
          method: "post",
          url: this.$api.newStockdividends,
          data: this.form,
        }).then((res) => {
          if (res.data.qmiscode == 1000) {
            App.oTool.successT("操作成功");
            this.father.handleCancel()
          } else {
            App.oTool.warningT(res.data.qmismsg);
          }
        });
      },
		
		}
}
</script>

<style lang="scss" scoped>
.numrule{
  text-align: right;
}
::v-deep .numrule input::-webkit-outer-spin-button,
::v-deep .numrule input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep .numrule input[type="number"] {
  -moz-appearance: textfield !important;

}
::v-deep .numrule input{
  height: 1.75rem;
  width: 100%;
  font-size: 0.8rem;
  color: #000;
}
::v-deep .numrule .el-input__inner:focus{
  height: 1.75rem;
  line-height: 1.75rem;
  border-color: #0c8b97;
}


</style>
<style>
@media screen and (min-width:2200px){
  .ant-select-selection--single .ant-select-selection__rendered{
    height: 1.75rem;
    font-size: 0.8rem !important;
  }
  .ant-calendar-picker-input, .ant-input{
    font-size: 0.8rem !important;

  }
}
</style>